import React, { useState } from "react";
import { Card, CardBody, Input, Button } from "@heroui/react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const BasicLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { instance, inProgress } = useMsal();

  const basicEnabled = process.env.REACT_APP_ENABLE_BASIC_LOGIN === "true";
  const allowedUser = process.env.REACT_APP_BASIC_USER || "admin" || process.env.REACT_APP_PDG_USER;
  const allowedPass = process.env.REACT_APP_BASIC_PASS || "admin123" || process.env.REACT_APP_PDG_PASS;
  const allowedUser2 = process.env.REACT_APP_PDG_USER || "admin"
  const allowedPass2 = process.env.REACT_APP_PDG_PASS || "admin123"

  const handleBasicLogin = (e) => {
    e.preventDefault();
    if (!basicEnabled) {
      setError("Basic login is disabled in this environment.");
      return;
    }
    if ((username === allowedUser && password === allowedPass) || (username === allowedUser2 && password === allowedPass2) ) {
      localStorage.setItem("basicAuthUser", username);
      // Force re-render of ProtectedEntryPoint
      window.location.reload();
    } else {
      setError("Invalid credentials");
    }
  };

  const handleMsLogin = async () => {
    // See Login.jsx: never call loginRedirect while MSAL is mid-interaction.
    if (inProgress !== InteractionStatus.None) return;
    try {
      await instance?.loginRedirect({ scopes: ["User.Read"] });
    } catch (err) {
      console.error("MS Login failed", err);
      setError("Microsoft login failed");
    }
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <Card className="w-full max-w-sm  max-h-md">
        <CardBody>
          <div className=" bg-transparent ps-4 pt-4 mb-6">
            <img src="/logo-pdg.svg" alt="Logo" className="w-full ps-1 pe-5 w-auto" />
          </div>
          <form onSubmit={handleBasicLogin} className="flex flex-col gap-3">
            <Input
              size="sm"
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Input
              size="sm"
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && <span className="text-danger text-sm">{error}</span>}
            <Button type="submit" className="w-full">
              Sign in
            </Button>
            <Button variant="flat" onPress={handleMsLogin} isDisabled={inProgress !== InteractionStatus.None} className="w-full">
              Login with Microsoft
            </Button>
          </form>
        </CardBody>
      </Card>
    </div>
  );
};

export default BasicLogin;






